import React from 'react'

const Currentmonthattandance = () => {
  return (
    <div>
      
    </div>
  )
}

export default Currentmonthattandance
